import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import css from './MyLocationRow.scss';
import classnames from 'classnames';
import Icon from 'SF/MaterialIcon';
import { isEmptyString } from 'utils/text';
import Select from 'common/StyledSelect';
import { components } from 'react-select';

/**
 * @param {Function} deleteLocation - called when a location should be deleted
 * @param {Function} editLocation - called when a location should be edited
 * @param {Object} location - the data for the location being rendered
 * @param {number} index - the row's index
 * @returns {node} the row representing a user's Location to be shown in the MyLocations table
 */
const MyLocationRow = ({ deleteLocation, editLocation, location, index }) => {
    const locationOption = optionProps => (
        <components.Option {...optionProps} className={css['location-option']}>
            <Icon icon={optionProps.data.icon} aria-hidden={true} />{optionProps.data.label}
        </components.Option>
    );
    
    const getLocationOptions = () => (
        <Select isMenu
            id={`location${index}Option`}
            className={css['location-options']}
            customOption={locationOption}
            ariaLabel={`${location.name} Options`}
            options={[{
                label: 'Edit',
                icon: 'edit',
                onSelect: editLocation
            }, {
                label: 'Delete',
                icon: 'delete',
                onSelect: () => deleteLocation(location)
            }]}
            onChange={selectedLocation => selectedLocation.onSelect()}
        />
    );
    
    const getInstructionsRow = () => isEmptyString(location.instructions) 
        ? null
        : (
            <Table.Row className={classnames(css['item-row'], css['instruction-row'])}>
                <Table.Cell className={css['wrap']} colSpan={3}>
                    <span className={css['sub-header']}>Instructions</span>
                    <br/>
                    {location.instructions}
                </Table.Cell>
            </Table.Row>
        );

    return (
        <Table.Body scope="row" data-testid={`locationRow${location.name.replace(/\s+/g, '')}`}>
            <Table.Row className={classnames(css['item-row'], css['primary-row'])}>
                <Table.Cell className={css['wrap']} width={7}>{location.name}</Table.Cell>
                <Table.Cell width={3}>{location.type[0] + location.type.toLowerCase().slice(1)}</Table.Cell>
                <Table.Cell width={1} collapsing>{getLocationOptions()}</Table.Cell>
            </Table.Row>
            {getInstructionsRow()}
        </Table.Body>
    )
};

MyLocationRow.propTypes = {
    deleteLocation: PropTypes.func,
    editLocation: PropTypes.func,
    index: PropTypes.number,
    location: PropTypes.shape({
        name: PropTypes.string,
        type: PropTypes.string,
        instructions: PropTypes.string
    })
};

export default MyLocationRow;
